import React, { forwardRef, useMemo } from "react";
import { Text as RNText } from "react-native";
import { style as textStyle } from "./Text.style";
const Text = forwardRef(({ variant = "body", children, level = 3, style: customStyle, ...rest }, ref) => {
    const style = useMemo(() => textStyle({
        variant,
        level,
    }), [variant, level]);
    return (React.createElement(RNText, { ref: ref, style: [style, customStyle], ...rest }, children));
});
Text.displayName = "Text";
export { Text };
